import React, { useCallback, useRef, useState } from 'react';
import { useTriggerOnClickOutsideElement } from '@lmt/unicorn-shared/app/helpers/useTriggerOnClickOutsideElement';
import { ToolBarIconButton } from './ToolBarIconButton';
import { OptionList } from '@lmt/unicorn-shared/app/components/common/ui-kit/OptionList';
import {
  BadgeColor,
  UserBadge,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/UserBadge';

import styles from './ToolBarDropDown.module.scss';

interface ToolBarOption {
  displayValue: string;
  value: string;
  onClick?: () => void;
  disabled?: boolean;
}

type ToolBarDropDownProps = {
  icon: React.FC;
  badge?: string;
  disabled?: boolean;
  options: ToolBarOption[];
  onOptionClick?: (value: ToolBarOption) => void;
  testId?: string;
};

export const ToolBarDropDown: React.FC<ToolBarDropDownProps> = (props) => {
  const { icon, disabled, options, onOptionClick, badge } = props;

  const [expanded, setExpanded] = useState<boolean>(false);
  const optionListRef = useRef<HTMLDivElement>(null);
  const hide = useCallback(() => setExpanded(false), [setExpanded]);
  useTriggerOnClickOutsideElement(optionListRef, hide, expanded);

  return (
    <div data-test-id={props.testId}>
      {badge ? (
        <UserBadge
          name={badge}
          onClick={() => setExpanded(!expanded)}
          className={styles.badge}
          color={BadgeColor.Dark}
        />
      ) : (
        <ToolBarIconButton
          icon={icon}
          disabled={disabled}
          onClick={() => setExpanded(!expanded)}
          testId="toolbarDropDown-Icon"
        />
      )}
      <OptionList<ToolBarOption>
        visible={expanded}
        options={options}
        onClick={(option) => {
          option.onClick?.();
          onOptionClick?.(option);
          setExpanded(false);
        }}
        labelField="displayValue"
        elementRef={optionListRef}
        className={styles.optionListContainer}
      />
    </div>
  );
};
